import isString from "lodash/isString";
import { Box, Typography, Link } from "@mui/material";
import Breadcrumbs from "./Breadcrumbs";

const HeaderBreadcrumbs = ({
  links,
  action,
  heading,
  moreLink = "" || [],
  sx,
  ...other
}: any) => {
  return (
    <Box sx={{ mb: { xs: 3, sm: 5 }, ...sx }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "stretch", sm: "center" },
          gap: { xs: 1.5, sm: 2 },
        }}
      >
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography
            variant="h4"
            gutterBottom
            sx={{ wordBreak: "break-word" }}
          >
            {heading}
          </Typography>
          <Breadcrumbs links={links} {...other} />
        </Box>

        {action && (
          <Box
            sx={{
              flexShrink: 0,
              width: { xs: "100%", sm: "auto" },
              "& > *": {
                width: { xs: "100%", sm: "auto" },
              },
            }}
          >
            {action}
          </Box>
        )}
      </Box>

      <Box sx={{ mt: 2 }}>
        {isString(moreLink) ? (
          <Link href={moreLink} target="_blank" rel="noopener" variant="body2">
            {moreLink}
          </Link>
        ) : (
          moreLink.map((href: any) => (
            <Link
              noWrap
              key={href}
              href={href}
              variant="body2"
              target="_blank"
              rel="noopener"
              sx={{ display: "table" }}
            >
              {href}
            </Link>
          ))
        )}
      </Box>
    </Box>
  );
};

export default HeaderBreadcrumbs;
